import { useState } from "react";
import WelcomeOverview from "../../features/welcome-overview/WelcomeOverview";
import PatientDashboard from "./PatientDashboard";
import PatientMainLayout from "../../layouts/main-layout/PatientMainLayout";
import { setHideNoShow } from "../opt-in-opt-out/services/PatientStatusSlice";
import { useAppDispatch } from "../../store/hooks";

const PatientDashboardWrapper = () => {
  const dispatch = useAppDispatch();
  const [showBannerOverlay, setShowBannerOverlay] = useState<boolean>(
    () => localStorage.getItem("showBannerOverlay") === "true"
  );

  const handleCloseWelcomeOverview = () => {
    localStorage.removeItem("showBannerOverlay");
    dispatch(setHideNoShow(true));
    setShowBannerOverlay(false);
  };

  return (
    <>
      {showBannerOverlay ? (
        <WelcomeOverview onClose={handleCloseWelcomeOverview} />
      ) : (
        <PatientMainLayout>
          <PatientDashboard />
        </PatientMainLayout>
      )}
    </>
  );
};

export default PatientDashboardWrapper;
